"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Chevron_1 = require("../Chevron/Chevron");
var InputLabel_1 = require("../InputLabel/InputLabel");
var Typography_1 = require("../Typography/Typography");
var Select_style_1 = __importDefault(require("./Select.style"));
/**
 * Select atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-inputs-select--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Select Source}
 */
var Select = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, errorMessage = _a.errorMessage, _c = _a.fontVariant, fontVariant = _c === void 0 ? 'body' : _c, helperText = _a.helperText, label = _a.label, labelLink = _a.labelLink, _d = _a.loading, loading = _d === void 0 ? false : _d, onChange = _a.onChange, placeholder = _a.placeholder, stopPropagation = _a.stopPropagation, _e = _a.value, value = _e === void 0 ? '' : _e, valueRenderer = _a.valueRenderer, _f = _a.variant, variant = _f === void 0 ? 'normal' : _f;
    var classes = (0, Select_style_1.default)({ fontVariant: fontVariant });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: stopPropagation ? function (event) { return event.stopPropagation(); } : undefined, className: (0, classnames_1.default)(classes.root, variant === 'normal' && classes.rootNormal, className) }, { children: [renderLabel(), (0, jsx_runtime_1.jsxs)(core_1.Select, __assign({ value: value, input: renderInput(), inputProps: { style: theme_1.default.fonts.body }, IconComponent: function (props) { return (0, jsx_runtime_1.jsx)(Chevron_1.Chevron, __assign({ height: '7px' }, props)); }, className: (0, classnames_1.default)(variant === 'small' && classes.selectRootSmall), MenuProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    },
                    getContentAnchorEl: null,
                    classes: { paper: classes.menuPaper, list: classes.menuList },
                }, classes: {
                    root: variant === 'small' ? classes.noPadding : undefined,
                    icon: variant === 'small' ? classes.iconSmall : classes.icon,
                    iconOpen: classes.iconOpen,
                    selectMenu: classes.selectMenu,
                }, onChange: function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange(event); }, displayEmpty: true, renderValue: renderValue() }, { children: [renderHelperText(), children] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.errorContainer }, { children: renderErrorText() }))] })));
    function renderValue() {
        if (!value) {
            return function () { return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ color: theme_1.default.textColors.primaryLighter, variant: fontVariant }, { children: placeholder }))); };
        }
        if (typeof valueRenderer === 'function') {
            return function () { return valueRenderer(value); };
        }
        return undefined;
    }
    function renderLabel() {
        if (variant === 'small') {
            return null;
        }
        return (0, jsx_runtime_1.jsx)(InputLabel_1.InputLabel, { label: label, link: labelLink, disabled: disabled });
    }
    function renderInput() {
        return ((0, jsx_runtime_1.jsx)(core_1.Input, { classes: {
                root: classes.inputRoot,
                focused: (0, classnames_1.default)(variant === 'small' && classes.noFocus, variant !== 'small' && errorMessage && classes.errorFocused, variant !== 'small' && !errorMessage && classes.focused),
                underline: (0, classnames_1.default)(variant !== 'small' && errorMessage && classes.errorUnderline, variant !== 'small' && !errorMessage && classes.underline),
                input: (0, classnames_1.default)(classes.input, variant === 'small' && classes.noPadding),
                disabled: (0, classnames_1.default)(disabled && classes.disabledUnderline),
            }, disabled: disabled }));
    }
    function renderHelperText() {
        if (!helperText && !loading) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', className: classes.helperText, color: theme_1.default.textColors.primaryLight, noWrap: true }, { children: loading ? 'Loading' : helperText })));
    }
    function renderErrorText() {
        if (!errorMessage) {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ variant: 'label1', className: classes.errorText, color: theme_1.default.textColors.error, noWrap: true }, { children: errorMessage })));
    }
};
exports.Select = Select;
